module.exports = __webpack_public_path__ + "img/logo.743bcbdd.png";